import React, { MouseEvent, useState } from "react";
import IconButton from "@mui/material/IconButton";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const PasswordField = (props: TextFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword(!showPassword);
  props = Object.assign({ type: showPassword ? "text" : "password" }, props);
  return (
    <TextField
      {...props}
      InputProps={{
        endAdornment: (
          <IconButton
            onClick={toggleShowPassword}
            onMouseDown={(event: MouseEvent<HTMLButtonElement>) => {
              event.preventDefault();
            }}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        ),
      }}
    />
  );
};

export default PasswordField;
